export default __webpack_public_path__ + "static/media/carousel-example.8b0993df.jpg";